import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';

import Loading from '../../components/Loading/Loading';
import loginActions from './LoginActions';
import style from './Login.module.css';
import webClientImage from '../../assets/img/webclient_pic.jpg';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login: '',
      password: '',
      globalMessage: '',
    };
  }
  
  componentDidMount() {
    this.getGlobalMessage();
  }
  
  getGlobalMessage = async () => {
    try {
      const response = await axios.get('/api/global-message');
      if(response.data) {
        this.setState({globalMessage: response.data});
      }
    } catch (err) {
      console.error(err);
    }
  }

  render() {
    const { user, password } = this.props;
    const {
      changeUser,
      changePassword,
      confirmLogin,
      loading,
      failed,
      success,
      message,
      isRestoring,
      goLogin,
      goRestore,
      restorePassword,
    } = this.props;

    const showErrorMessage = () =>
      failed === true && <div className="alert alert-danger">{message}</div>;

    return (
      <div className="row">
        <div className={`col-md-12 mt-4 ${style.Home}`}>
          {loading && <Loading/>}

          <h1 className={style.login_h}><Translate value="common.LogoFull"/></h1>
          
          {
            this.state.globalMessage &&
            <div style={{background: "#ffc235", padding: 20, margin: "20px 0px"}}>
              <h3 style={{textAlign: "center", color: "#333", fontWeight: "bold"}}>{this.state.globalMessage}</h3>
            </div>
          }

          <div className={style.login_container}>
            <div>
              {!isRestoring ?
                <form className={`form ${style.jumbotron}`}>
                  <h2 style={{ marginTop: 0 }}>
                    <Translate value="auth.Login"/>
                  </h2>
                  <div className="mb-3">
                    <label htmlFor="user" className={style.margin}>
                      <Translate value="auth.User"/>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${style.margin}`}
                      id="user"
                      value={user}
                      onChange={changeUser}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className={style.margin}>
                      <Translate value="auth.Password"/>
                    </label>
                    <input
                      type="password"
                      className={`form-control ${style.margin}`}
                      id="password"
                      value={password}
                      onChange={changePassword}
                    />
                  </div>
                  {showErrorMessage()}
                  <div className="row">
                    <div className="col-sm-6">
                      <button
                        className="btn btn-default"
                        onClick={confirmLogin.bind(null, user, password)}
                      ><Translate value="auth.Login"/>
                      </button>
                    </div>
                    <div className="col-sm-6 text-end">
                      <a href="#" className="align-middle" onClick={goRestore}>
                        <Translate value="auth.forgotQuestion"/>
                      </a>
                    </div>
                  </div>
                </form>
                :
                <form className={`form ${style.jumbotron}`}>
                  <h2 style={{ marginTop: 0 }}><Translate value="auth.restoreTitle"/></h2>
                  {!!success}

                  {success ? <p><Translate value="auth.sentRestoreTitle"/></p> :
                    <div>
                      <div className="mb-3">
                        <label htmlFor="user" className={style.margin}><Translate
                          value="auth.User"/></label>
                        <input
                          type="text"
                          className={`form-control ${style.margin}`}
                          id="user"
                          value={user}
                          onChange={changeUser}
                        />
                      </div>
                      {showErrorMessage()}
                      <div className="row">
                        <div className="col-sm-6">
                          <button
                            className="btn btn-default"
                            onClick={restorePassword.bind(null, user)}
                          ><Translate value="Restore"/>
                          </button>
                        </div>
                        <div className="col-sm-6 text-end">
                          <a href="#" className="align-middle" onClick={goLogin}>
                            <Translate value="auth.goToLogin"/>
                          </a>
                        </div>
                      </div>
                    </div>
                  }
                </form>
              }
            </div>
            <div className={style.login_webclient_box} style={{ backgroundImage: 'url('+webClientImage+')' }}>
              <a href="/webclient/#/login?hide_ui=true" className={'btn btn-primary '+style.login_webclient_btn}>Participant login</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  user: PropTypes.string,
  password: PropTypes.string,
  message: PropTypes.string,
  hello: PropTypes.string,
  loading: PropTypes.bool,
  changeUser: PropTypes.func,
  changePassword: PropTypes.func,
  confirmLogin: PropTypes.func,
  failed: PropTypes.bool,
  isRestoring: PropTypes.bool,
  success: PropTypes.bool,
  goLogin: PropTypes.func,
  goRestore: PropTypes.func,
  restorePassword: PropTypes.func,
};

const mapStateToProps = state => ({
  user: state.login.user,
  password: state.login.password,
  loading: state.login.loading,
  message: state.login.message,
  failed: state.login.failed,
  success: state.login.success,
  isRestoring: state.login.isRestoring,
});

const mapDispatchToProps = {
  changeUser: loginActions.changeUser,
  changePassword: loginActions.changePassword,
  confirmLogin: loginActions.login,
  goLogin: loginActions.goLogin,
  goRestore: loginActions.goRestore,
  restorePassword: loginActions.restorePassword,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);
